import React from 'react';

export default function PDFLayout({ 
  filtered, 
  categories, 
  restaurant 
}) {
    // This layout is View-Only designed for easy printing/rendering
    return (
        <div className="layout-pdf bg-white p-6 rounded-lg shadow-sm border border-slate-100 max-w-3xl mx-auto my-8 print:shadow-none print:border-none print:m-0 print:p-0">
            {/* Header */}
            <div className="text-center mb-10 pb-6 border-b-2 border-charcoal/10">
                {restaurant?.logo_url && (
                    <img src={restaurant.logo_url} alt="Logo" className="w-20 h-20 object-contain mx-auto mb-4" />
                )}
                <h1 className="text-4xl font-black text-charcoal tracking-wider uppercase font-serif">
                    {restaurant?.name || 'Menu'}
                </h1>
                <p className="text-sm text-slate-500 mt-2 italic font-serif">
                    {restaurant?.description || 'A delicious culinary experience'}
                </p>
                {restaurant?.phone && (
                    <p className="text-xs font-bold text-slate-400 mt-2 tracking-widest uppercase">
                        Reservations: {restaurant.phone}
                    </p>
                )}
            </div>

            {/* Menu Sections */}
            <div className="columns-1 md:columns-2 gap-12 print:columns-2">
                {categories.filter(cat => cat !== 'All').map(cat => {
                    const catDishes = filtered.filter(d => d.category === cat);
                    if (catDishes.length === 0) return null;
                    return (
                        <div key={cat} className="break-inside-avoid mb-8">
                            <h2 className="text-xl font-bold text-charcoal mb-4 pb-1 border-b border-primary/50 uppercase tracking-widest font-serif inline-block">
                                {cat}
                            </h2>
                            <div className="flex flex-col gap-4">
                                {catDishes.map(dish => {
                                    const isVeg = dish.type === 'veg';
                                    return (
                                        <div key={dish.id} className="relative">
                                            <div className="flex items-end justify-between gap-4 mb-0.5">
                                                <div className="flex items-center gap-1.5 flex-1 min-w-0">
                                                    <div className={`mt-0.5 flex-shrink-0 w-2.5 h-2.5 rounded-[1px] border flex items-center justify-center
                                                        ${isVeg ? 'border-green-600 bg-green-50' : 'border-red-500 bg-red-50'}`}>
                                                        <div className={`w-1 h-1 rounded-full ${isVeg ? 'bg-green-600' : 'bg-red-500'}`} />
                                                    </div>
                                                    <h3 className="font-bold text-sm text-charcoal whitespace-nowrap">{dish.name}</h3>
                                                    {/* Leader line dots */}
                                                    <div className="flex-1 border-b border-dotted border-slate-300 relative -top-1.5 mx-1" />
                                                </div>
                                                <span className="font-black text-sm text-charcoal px-1 bg-white">
                                                    {Number(dish.price).toFixed(0)}
                                                </span>
                                            </div>
                                            {dish.description && (
                                                <p className="text-[10px] text-slate-500 italic pr-12 leading-snug">
                                                    {dish.description}
                                                </p>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
            
            <div className="mt-12 pt-6 border-t border-charcoal/10 text-center text-xs text-slate-400 font-serif italic print:hidden">
                <button 
                  onClick={() => window.print()} 
                  className="px-4 py-2 border border-slate-200 rounded hover:bg-slate-50 transition-colors"
                >
                    Print or Save as PDF
                </button>
            </div>
        </div>
    );
}
